var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMultiColorFire = function SvgMultiColorFire(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2184 14.4401C21.2184 19.1676 17.1553 23 12.1434 23C7.13138 23 3.06836 19.1676 3.06836 14.4401C3.06836 9.01275 9.08821 3.25919 11.3221 1.31099C11.7975 0.896305 12.4891 0.896343 12.9646 1.31107C15.1984 3.2596 21.2184 9.01417 21.2184 14.4401Z",
    fill: "#FF4B4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2732 16.8421C16.2732 19.0276 14.4234 20.7993 12.1415 20.7993C9.8596 20.7993 8.00977 19.0276 8.00977 16.8421C8.00977 14.3331 10.7505 11.6733 11.7676 10.7727C11.984 10.581 12.2989 10.581 12.5154 10.7727C13.5324 11.6735 16.2732 14.3338 16.2732 16.8421Z",
    fill: "#FCD97D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMultiColorFire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/multi-color-fire.236ff1c56f9bc327b4354221e82b3507.svg";